// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__u0wIH","input":"Input_input__E5rzA","label":"Input_label__NXpCD"};